var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuitar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 94,
    viewBox: "0 0 86 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6001 2.6499V37.6103",
    stroke: "#D89F5B",
    strokeWidth: 4.0121,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5999 23.0269C32.2999 23.0269 24.4999 25.8237 24.4999 33.7148C24.4999 41.6058 27.8999 45.6013 27.8999 49.1972C27.8999 55.9895 18.3999 59.086 18.3999 73.7694",
    stroke: "#D89F5B",
    strokeWidth: 4.0121,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6001 2.6499V37.6103",
    stroke: "#D89F5B",
    strokeWidth: 4.0121,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6001 23.0269C53.9001 23.0269 61.7001 25.8237 61.7001 33.7148C61.7001 41.6058 58.3001 45.6013 58.3001 49.1972C58.3001 55.9895 67.8001 59.086 67.8001 73.7694",
    stroke: "#D89F5B",
    strokeWidth: 4.0121,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8999 52.3936C47.0999 53.1927 51.5999 48.7976 50.7999 43.5036C50.2999 40.2074 47.5999 37.6103 44.3999 37.1109C39.1999 36.3118 34.6999 40.7068 35.4999 46.0008C35.9999 49.1972 38.6999 51.8941 41.8999 52.3936Z",
    stroke: "#D89F5B",
    strokeWidth: 4.0121,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1 2.6499H81.2C82.3 2.6499 83.2 3.54888 83.2 4.64764V60.3846C83.2 61.6831 82.6 62.8817 81.6 63.5809L45.5 90.2507C44.1 91.2496 42.2 91.2496 40.7 90.2507L4.6 63.6808C3.6 62.8817 3 61.6831 3 60.4844V4.64764C3 3.54888 3.9 2.6499 5 2.6499H43.1Z",
    stroke: "#D89F5B",
    strokeWidth: 4.0121,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuitar);
export default __webpack_public_path__ + "static/media/guitar.ae78c20e10492af052421cae2a1483ec.svg";
export { ForwardRef as ReactComponent };